// extracted by mini-css-extract-plugin
export default {"featured":"Style_featured__Upt4K","top":"Style_top__6Y82g","title":"Style_title__ZJLQm","bottom":"Style_bottom__WJAz4","featuredChart":"Style_featuredChart__F6jmM"};